import { Link } from 'react-router-dom'
export default function Header() {
    return <div className='headerFrame'>
        <Link className='quiz_header' to="/">Quiz App</Link>
    </div>


}